import { render, staticRenderFns } from "./OrderOneClickAction.vue?vue&type=template&id=0065616e&scoped=true"
import script from "./OrderOneClickAction.vue?vue&type=script&lang=js"
export * from "./OrderOneClickAction.vue?vue&type=script&lang=js"
import style0 from "./OrderOneClickAction.vue?vue&type=style&index=0&id=0065616e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0065616e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0065616e')) {
      api.createRecord('0065616e', component.options)
    } else {
      api.reload('0065616e', component.options)
    }
    module.hot.accept("./OrderOneClickAction.vue?vue&type=template&id=0065616e&scoped=true", function () {
      api.rerender('0065616e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/OrderOneClickAction.vue"
export default component.exports